import { Col, Row } from 'antd';
import styled from 'styled-components';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import {
  boxShadow,
  maxWidth,
  retina,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
 box-shadow : ${boxShadow};
 background-color: transparent;
 border-radius: 12px;
 padding: 17px 24px;
 height: 670px;
 width: auto;
 .pulse-col {
    .skeleton-box {
      margin-block: 4px;
    }
  }
 .tabs-wrapper {
    display: flex;
    justify-content: space-between;
    width: 100%;
 }
 .triggers-col {
   .ant-pulse-triggers {
     display: flex;
     justify-content: space-between;
     height: 100%;
     padding-top: 10px;
     .ant-col-triggers {
        flex: 0 0 25%;
        .skeleton-box {
          @media all and (min-width: 1900px) {
            margin: 4px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            margin: 4px;
          }
        }
      } 
    }
  }
`;

const PulseBoardFullSkeleton = function PulseBoardFullSkeleton() {
  return (
    <Wrapper className="pulse-skeleton-wrapper">
      <div className="heading-inner-page mb-c-10">
        <div className="tabs-wrapper">
          {[1, 2].map((val) => (
            <span className="resolution-fix pulse-board-tabs">
              <SkeletonCustom
                height="30px"
                width="80px"
                diameter="10px"
                margin="0 13px 0 0"
                key={val}
              />
            </span>
          ))}
        </div>
      </div>
      <Row className="pulse-row">
        <Col span={24} className="pulse-col">
          {
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
              (val) => (
                <SkeletonCustom
                  height="22px"
                  width="100%"
                  diameter="10px"
                  margin="4px 0px"
                  key={val}
                />
              ),
            )
          }
        </Col>
        <Col span={24} className="triggers-col">
          <Row className="ant-pulse-triggers">
            {
              [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24].map((val) => (
                <Col className="ant-col-triggers">
                  <SkeletonCustom height="20px" width="60px" diameter="10px" margin="0px" key={val} />
                </Col>
              ))
            }
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
};
export default PulseBoardFullSkeleton;
